/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestError from '../model/BadRequestError';
import Comment from '../model/Comment';
import CommentCreate from '../model/CommentCreate';
import CommentList from '../model/CommentList';
import CommentRead from '../model/CommentRead';
import CommentUpdate from '../model/CommentUpdate';
import CommentVersionList from '../model/CommentVersionList';
import CommentVersionRead from '../model/CommentVersionRead';
import CommentVersionWrite from '../model/CommentVersionWrite';
import ForbiddenError from '../model/ForbiddenError';
import InlineObject from '../model/InlineObject';
import InlineObject1 from '../model/InlineObject1';
import InlineObject11 from '../model/InlineObject11';
import InlineObject12 from '../model/InlineObject12';
import InlineObject13 from '../model/InlineObject13';
import InlineObject15 from '../model/InlineObject15';
import InlineObject16 from '../model/InlineObject16';
import InlineObject17 from '../model/InlineObject17';
import InlineObject2 from '../model/InlineObject2';
import InlineObject20 from '../model/InlineObject20';
import InlineObject22 from '../model/InlineObject22';
import InlineObject23 from '../model/InlineObject23';
import InlineObject24 from '../model/InlineObject24';
import InlineObject25 from '../model/InlineObject25';
import InlineObject26 from '../model/InlineObject26';
import InlineObject6 from '../model/InlineObject6';
import InlineObject7 from '../model/InlineObject7';
import InlineObject8 from '../model/InlineObject8';
import InlineResponse200 from '../model/InlineResponse200';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import ServiceUnavailableError from '../model/ServiceUnavailableError';
import ShortNameApproveCommentRead from '../model/ShortNameApproveCommentRead';
import UnauthorizedError from '../model/UnauthorizedError';
import VoteCreate from '../model/VoteCreate';
import VoteList from '../model/VoteList';
import VoteRead from '../model/VoteRead';
import VoteUpdate from '../model/VoteUpdate';

/**
* Comment service.
* @module api/CommentApi
* @version 1.7.2
*/
export default class CommentApi {

    /**
    * Constructs a new CommentApi. 
    * @alias module:api/CommentApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the approveCommentForArticle operation.
     * @callback module:api/CommentApi~approveCommentForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ShortNameApproveCommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Approve comment for Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject} opts.comment 
     * @param {module:api/CommentApi~approveCommentForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ShortNameApproveCommentRead}
     */
    approveCommentForArticle(acceptLanguage, articleId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling approveCommentForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling approveCommentForArticle");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling approveCommentForArticle");
      }

      let pathParams = {
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ShortNameApproveCommentRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{id}/approve', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the approveCommentForImage operation.
     * @callback module:api/CommentApi~approveCommentForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ShortNameApproveCommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Approve comment for Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject8} opts.comment 
     * @param {module:api/CommentApi~approveCommentForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ShortNameApproveCommentRead}
     */
    approveCommentForImage(acceptLanguage, imageId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling approveCommentForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling approveCommentForImage");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling approveCommentForImage");
      }

      let pathParams = {
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ShortNameApproveCommentRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{id}/approve', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the approveCommentForProduct operation.
     * @callback module:api/CommentApi~approveCommentForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ShortNameApproveCommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Approve comment for Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject13} opts.comment 
     * @param {module:api/CommentApi~approveCommentForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ShortNameApproveCommentRead}
     */
    approveCommentForProduct(acceptLanguage, productId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling approveCommentForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling approveCommentForProduct");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling approveCommentForProduct");
      }

      let pathParams = {
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ShortNameApproveCommentRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{id}/approve', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the approveCommentForRecipe operation.
     * @callback module:api/CommentApi~approveCommentForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ShortNameApproveCommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Approve comment for Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject17} opts.comment 
     * @param {module:api/CommentApi~approveCommentForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ShortNameApproveCommentRead}
     */
    approveCommentForRecipe(acceptLanguage, recipeId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling approveCommentForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling approveCommentForRecipe");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling approveCommentForRecipe");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ShortNameApproveCommentRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{id}/approve', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the approveCommentForTaxon operation.
     * @callback module:api/CommentApi~approveCommentForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ShortNameApproveCommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Approve comment for Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject23} opts.comment 
     * @param {module:api/CommentApi~approveCommentForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ShortNameApproveCommentRead}
     */
    approveCommentForTaxon(acceptLanguage, taxonomyName, taxonId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling approveCommentForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling approveCommentForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling approveCommentForTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling approveCommentForTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ShortNameApproveCommentRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{id}/approve', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the approveCommentForVideo operation.
     * @callback module:api/CommentApi~approveCommentForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ShortNameApproveCommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Approve comment for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject26} opts.comment 
     * @param {module:api/CommentApi~approveCommentForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ShortNameApproveCommentRead}
     */
    approveCommentForVideo(acceptLanguage, videoId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling approveCommentForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling approveCommentForVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling approveCommentForVideo");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ShortNameApproveCommentRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{id}/approve', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createArticleComment operation.
     * @callback module:api/CommentApi~createArticleCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Comment for Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {module:model/CommentCreate} comment The new Comment resource
     * @param {module:api/CommentApi~createArticleCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    createArticleComment(acceptLanguage, articleId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createArticleComment");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling createArticleComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createArticleComment");
      }

      let pathParams = {
        'article_id': articleId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createArticleCommentVote operation.
     * @callback module:api/CommentApi~createArticleCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/CommentApi~createArticleCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createArticleCommentVote(acceptLanguage, articleId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createArticleCommentVote");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling createArticleCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createArticleCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createArticleCommentVote");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForArticle operation.
     * @callback module:api/CommentApi~createCommentVersionForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/CommentApi~createCommentVersionForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForArticle(acceptLanguage, articleId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling createCommentVersionForArticle");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForArticle");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForArticle");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForImage operation.
     * @callback module:api/CommentApi~createCommentVersionForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/CommentApi~createCommentVersionForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForImage(acceptLanguage, imageId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling createCommentVersionForImage");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForImage");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForImage");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForProduct operation.
     * @callback module:api/CommentApi~createCommentVersionForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/CommentApi~createCommentVersionForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForProduct(acceptLanguage, productId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling createCommentVersionForProduct");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForProduct");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForProduct");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForRecipe operation.
     * @callback module:api/CommentApi~createCommentVersionForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/CommentApi~createCommentVersionForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForRecipe(acceptLanguage, recipeId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling createCommentVersionForRecipe");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForRecipe");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForRecipe");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForTaxon operation.
     * @callback module:api/CommentApi~createCommentVersionForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/CommentApi~createCommentVersionForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForTaxon(acceptLanguage, taxonomyName, taxonId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling createCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling createCommentVersionForTaxon");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForTaxon");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForVideo operation.
     * @callback module:api/CommentApi~createCommentVersionForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/CommentApi~createCommentVersionForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForVideo(acceptLanguage, videoId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createCommentVersionForVideo");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForVideo");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForVideo");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createImageComment operation.
     * @callback module:api/CommentApi~createImageCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Comment for Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {module:model/CommentCreate} comment The new Comment resource
     * @param {module:api/CommentApi~createImageCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    createImageComment(acceptLanguage, imageId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createImageComment");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling createImageComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createImageComment");
      }

      let pathParams = {
        'image_id': imageId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createImageCommentVote operation.
     * @callback module:api/CommentApi~createImageCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/CommentApi~createImageCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createImageCommentVote(acceptLanguage, imageId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createImageCommentVote");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling createImageCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createImageCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createImageCommentVote");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createProductComment operation.
     * @callback module:api/CommentApi~createProductCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Comment for Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {module:model/CommentCreate} comment The new Comment resource
     * @param {module:api/CommentApi~createProductCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    createProductComment(acceptLanguage, productId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createProductComment");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling createProductComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createProductComment");
      }

      let pathParams = {
        'product_id': productId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createProductCommentVote operation.
     * @callback module:api/CommentApi~createProductCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/CommentApi~createProductCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createProductCommentVote(acceptLanguage, productId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createProductCommentVote");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling createProductCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createProductCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createProductCommentVote");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createRecipeComment operation.
     * @callback module:api/CommentApi~createRecipeCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Comment for Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {module:model/CommentCreate} comment The new Comment resource
     * @param {module:api/CommentApi~createRecipeCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    createRecipeComment(acceptLanguage, recipeId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createRecipeComment");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling createRecipeComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createRecipeComment");
      }

      let pathParams = {
        'recipe_id': recipeId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createRecipeCommentVote operation.
     * @callback module:api/CommentApi~createRecipeCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/CommentApi~createRecipeCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createRecipeCommentVote(acceptLanguage, recipeId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createRecipeCommentVote");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling createRecipeCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createRecipeCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createRecipeCommentVote");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createTaxonComment operation.
     * @callback module:api/CommentApi~createTaxonCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Comment for Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {module:model/CommentCreate} comment The new Comment resource
     * @param {module:api/CommentApi~createTaxonCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    createTaxonComment(acceptLanguage, taxonomyName, taxonId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createTaxonComment");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling createTaxonComment");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling createTaxonComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createTaxonComment");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createTaxonCommentVote operation.
     * @callback module:api/CommentApi~createTaxonCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/CommentApi~createTaxonCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createTaxonCommentVote(acceptLanguage, taxonomyName, taxonId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createTaxonCommentVote");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling createTaxonCommentVote");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling createTaxonCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createTaxonCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createTaxonCommentVote");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createVideoComment operation.
     * @callback module:api/CommentApi~createVideoCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Comment for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {module:model/CommentCreate} comment The new Comment resource
     * @param {module:api/CommentApi~createVideoCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    createVideoComment(acceptLanguage, videoId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createVideoComment");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createVideoComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createVideoComment");
      }

      let pathParams = {
        'video_id': videoId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createVideoCommentVote operation.
     * @callback module:api/CommentApi~createVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/CommentApi~createVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createVideoCommentVote(acceptLanguage, videoId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createVideoCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteArticleComment operation.
     * @callback module:api/CommentApi~deleteArticleCommentCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Comment resource of Article.
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteArticleCommentCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteArticleComment(articleId, id, callback) {
      let postBody = null;
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling deleteArticleComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteArticleComment");
      }

      let pathParams = {
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteArticleCommentVote operation.
     * @callback module:api/CommentApi~deleteArticleCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Article.
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteArticleCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteArticleCommentVote(articleId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling deleteArticleCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteArticleCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteArticleCommentVote");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteImageComment operation.
     * @callback module:api/CommentApi~deleteImageCommentCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Comment resource of Image.
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteImageCommentCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteImageComment(imageId, id, callback) {
      let postBody = null;
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling deleteImageComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteImageComment");
      }

      let pathParams = {
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteImageCommentVote operation.
     * @callback module:api/CommentApi~deleteImageCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Image.
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteImageCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteImageCommentVote(imageId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling deleteImageCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteImageCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteImageCommentVote");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteProductComment operation.
     * @callback module:api/CommentApi~deleteProductCommentCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Comment resource of Product.
     * @param {String} productId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteProductCommentCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteProductComment(productId, id, callback) {
      let postBody = null;
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling deleteProductComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteProductComment");
      }

      let pathParams = {
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteProductCommentVote operation.
     * @callback module:api/CommentApi~deleteProductCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Product.
     * @param {String} productId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteProductCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteProductCommentVote(productId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling deleteProductCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteProductCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteProductCommentVote");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteRecipeComment operation.
     * @callback module:api/CommentApi~deleteRecipeCommentCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Comment resource of Recipe.
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteRecipeCommentCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteRecipeComment(recipeId, id, callback) {
      let postBody = null;
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling deleteRecipeComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteRecipeComment");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteRecipeCommentVote operation.
     * @callback module:api/CommentApi~deleteRecipeCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Recipe.
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteRecipeCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteRecipeCommentVote(recipeId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling deleteRecipeCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteRecipeCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteRecipeCommentVote");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteTaxonComment operation.
     * @callback module:api/CommentApi~deleteTaxonCommentCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Comment resource of Taxon.
     * @param {String} taxonId 
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteTaxonCommentCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteTaxonComment(taxonId, taxonomyName, id, callback) {
      let postBody = null;
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling deleteTaxonComment");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling deleteTaxonComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteTaxonComment");
      }

      let pathParams = {
        'taxon_id': taxonId,
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteTaxonCommentVote operation.
     * @callback module:api/CommentApi~deleteTaxonCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Taxon.
     * @param {String} taxonId 
     * @param {String} taxonomyName 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteTaxonCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteTaxonCommentVote(taxonId, taxonomyName, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling deleteTaxonCommentVote");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling deleteTaxonCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteTaxonCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteTaxonCommentVote");
      }

      let pathParams = {
        'taxon_id': taxonId,
        'taxonomy_name': taxonomyName,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteVideoComment operation.
     * @callback module:api/CommentApi~deleteVideoCommentCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Comment resource of Video.
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteVideoCommentCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteVideoComment(videoId, id, callback) {
      let postBody = null;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling deleteVideoComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteVideoComment");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteVideoCommentVote operation.
     * @callback module:api/CommentApi~deleteVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Video.
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~deleteVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteVideoCommentVote(videoId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling deleteVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleComment operation.
     * @callback module:api/CommentApi~getArticleCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Comment resource of Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:api/CommentApi~getArticleCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    getArticleComment(acceptLanguage, articleId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleComment");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getArticleComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getArticleComment");
      }

      let pathParams = {
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleCommentList operation.
     * @callback module:api/CommentApi~getArticleCommentListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment resources for Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getArticleCommentListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentList>}
     */
    getArticleCommentList(acceptLanguage, articleId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleCommentList");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getArticleCommentList");
      }

      let pathParams = {
        'article_id': articleId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentList];
      return this.apiClient.callApi(
        '/articles/{article_id}/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleCommentOptions operation.
     * @callback module:api/CommentApi~getArticleCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve the Article resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/CommentApi~getArticleCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse200}
     */
    getArticleCommentOptions(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getArticleCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/articles/{id}/options/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleCommentVote operation.
     * @callback module:api/CommentApi~getArticleCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~getArticleCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getArticleCommentVote(acceptLanguage, articleId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleCommentVote");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getArticleCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getArticleCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getArticleCommentVote");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleCommentVoteList operation.
     * @callback module:api/CommentApi~getArticleCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getArticleCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getArticleCommentVoteList(acceptLanguage, articleId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleCommentVoteList");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getArticleCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getArticleCommentVoteList");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentCollection operation.
     * @callback module:api/CommentApi~getCommentCollectionCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getCommentCollectionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentList>}
     */
    getCommentCollection(acceptLanguage, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentCollection");
      }

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentList];
      return this.apiClient.callApi(
        '/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForArticle operation.
     * @callback module:api/CommentApi~getCommentVersionForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Article.
     * @param {String} commentId 
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:api/CommentApi~getCommentVersionForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForArticle(commentId, articleId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getCommentVersionForArticle");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForArticle");
      }

      let pathParams = {
        'comment_id': commentId,
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForImage operation.
     * @callback module:api/CommentApi~getCommentVersionForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Image.
     * @param {String} commentId 
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:api/CommentApi~getCommentVersionForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForImage(commentId, imageId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getCommentVersionForImage");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForImage");
      }

      let pathParams = {
        'comment_id': commentId,
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForProduct operation.
     * @callback module:api/CommentApi~getCommentVersionForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Product.
     * @param {String} commentId 
     * @param {String} productId 
     * @param {String} id 
     * @param {module:api/CommentApi~getCommentVersionForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForProduct(commentId, productId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getCommentVersionForProduct");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForProduct");
      }

      let pathParams = {
        'comment_id': commentId,
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForRecipe operation.
     * @callback module:api/CommentApi~getCommentVersionForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Recipe.
     * @param {String} commentId 
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:api/CommentApi~getCommentVersionForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForRecipe(commentId, recipeId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getCommentVersionForRecipe");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForRecipe");
      }

      let pathParams = {
        'comment_id': commentId,
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForTaxon operation.
     * @callback module:api/CommentApi~getCommentVersionForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Taxon.
     * @param {String} commentId 
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {module:api/CommentApi~getCommentVersionForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForTaxon(commentId, taxonomyName, taxonId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getCommentVersionForTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForTaxon");
      }

      let pathParams = {
        'comment_id': commentId,
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForVideo operation.
     * @callback module:api/CommentApi~getCommentVersionForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Video.
     * @param {String} commentId 
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:api/CommentApi~getCommentVersionForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForVideo(commentId, videoId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getCommentVersionForVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForVideo");
      }

      let pathParams = {
        'comment_id': commentId,
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForArticle operation.
     * @callback module:api/CommentApi~getCommentVersionListForArticleCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getCommentVersionListForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForArticle(acceptLanguage, articleId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getCommentVersionListForArticle");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForArticle");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForImage operation.
     * @callback module:api/CommentApi~getCommentVersionListForImageCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getCommentVersionListForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForImage(acceptLanguage, imageId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getCommentVersionListForImage");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForImage");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForProduct operation.
     * @callback module:api/CommentApi~getCommentVersionListForProductCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getCommentVersionListForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForProduct(acceptLanguage, productId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getCommentVersionListForProduct");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForProduct");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForRecipe operation.
     * @callback module:api/CommentApi~getCommentVersionListForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getCommentVersionListForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForRecipe(acceptLanguage, recipeId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getCommentVersionListForRecipe");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForRecipe");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForTaxon operation.
     * @callback module:api/CommentApi~getCommentVersionListForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getCommentVersionListForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForTaxon(acceptLanguage, taxonomyName, taxonId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getCommentVersionListForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getCommentVersionListForTaxon");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForVideo operation.
     * @callback module:api/CommentApi~getCommentVersionListForVideoCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getCommentVersionListForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForVideo(acceptLanguage, videoId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getCommentVersionListForVideo");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForVideo");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageComment operation.
     * @callback module:api/CommentApi~getImageCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Comment resource of Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:api/CommentApi~getImageCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    getImageComment(acceptLanguage, imageId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageComment");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getImageComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageComment");
      }

      let pathParams = {
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageCommentList operation.
     * @callback module:api/CommentApi~getImageCommentListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment resources for Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getImageCommentListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentList>}
     */
    getImageCommentList(acceptLanguage, imageId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageCommentList");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getImageCommentList");
      }

      let pathParams = {
        'image_id': imageId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentList];
      return this.apiClient.callApi(
        '/images/{image_id}/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageCommentOptions operation.
     * @callback module:api/CommentApi~getImageCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve the Image resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/CommentApi~getImageCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse200}
     */
    getImageCommentOptions(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/images/{id}/options/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageCommentVote operation.
     * @callback module:api/CommentApi~getImageCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~getImageCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getImageCommentVote(acceptLanguage, imageId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageCommentVote");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getImageCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getImageCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageCommentVote");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageCommentVoteList operation.
     * @callback module:api/CommentApi~getImageCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getImageCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getImageCommentVoteList(acceptLanguage, imageId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageCommentVoteList");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getImageCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getImageCommentVoteList");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductComment operation.
     * @callback module:api/CommentApi~getProductCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Comment resource of Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} id 
     * @param {module:api/CommentApi~getProductCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    getProductComment(acceptLanguage, productId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductComment");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getProductComment");
      }

      let pathParams = {
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductCommentList operation.
     * @callback module:api/CommentApi~getProductCommentListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment resources for Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getProductCommentListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentList>}
     */
    getProductCommentList(acceptLanguage, productId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductCommentList");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductCommentList");
      }

      let pathParams = {
        'product_id': productId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentList];
      return this.apiClient.callApi(
        '/products/{product_id}/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductCommentOptions operation.
     * @callback module:api/CommentApi~getProductCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve the Product resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/CommentApi~getProductCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse200}
     */
    getProductCommentOptions(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getProductCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/products/{id}/options/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductCommentVote operation.
     * @callback module:api/CommentApi~getProductCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~getProductCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getProductCommentVote(acceptLanguage, productId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductCommentVote");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getProductCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getProductCommentVote");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductCommentVoteList operation.
     * @callback module:api/CommentApi~getProductCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getProductCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getProductCommentVoteList(acceptLanguage, productId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductCommentVoteList");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getProductCommentVoteList");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeComment operation.
     * @callback module:api/CommentApi~getRecipeCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Comment resource of Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:api/CommentApi~getRecipeCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    getRecipeComment(acceptLanguage, recipeId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeComment");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getRecipeComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getRecipeComment");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeCommentList operation.
     * @callback module:api/CommentApi~getRecipeCommentListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment resources for Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getRecipeCommentListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentList>}
     */
    getRecipeCommentList(acceptLanguage, recipeId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeCommentList");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getRecipeCommentList");
      }

      let pathParams = {
        'recipe_id': recipeId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentList];
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeCommentOptions operation.
     * @callback module:api/CommentApi~getRecipeCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve the Recipe resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/CommentApi~getRecipeCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse200}
     */
    getRecipeCommentOptions(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getRecipeCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/recipes/{id}/options/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeCommentVote operation.
     * @callback module:api/CommentApi~getRecipeCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~getRecipeCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getRecipeCommentVote(acceptLanguage, recipeId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeCommentVote");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getRecipeCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getRecipeCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getRecipeCommentVote");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeCommentVoteList operation.
     * @callback module:api/CommentApi~getRecipeCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getRecipeCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getRecipeCommentVoteList(acceptLanguage, recipeId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeCommentVoteList");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getRecipeCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getRecipeCommentVoteList");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonComment operation.
     * @callback module:api/CommentApi~getTaxonCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Comment resource of Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {module:api/CommentApi~getTaxonCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    getTaxonComment(acceptLanguage, taxonomyName, taxonId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonComment");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonComment");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getTaxonComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonComment");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonCommentList operation.
     * @callback module:api/CommentApi~getTaxonCommentListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment resources for Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getTaxonCommentListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentList>}
     */
    getTaxonCommentList(acceptLanguage, taxonomyName, taxonId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonCommentList");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonCommentList");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getTaxonCommentList");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentList];
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonCommentOptions operation.
     * @callback module:api/CommentApi~getTaxonCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve the Taxon resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:api/CommentApi~getTaxonCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse200}
     */
    getTaxonCommentOptions(acceptLanguage, taxonomyName, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonCommentOptions");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonCommentOptions");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}/options/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonCommentVote operation.
     * @callback module:api/CommentApi~getTaxonCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~getTaxonCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getTaxonCommentVote(acceptLanguage, taxonomyName, taxonId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonCommentVote");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonCommentVote");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getTaxonCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getTaxonCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonCommentVote");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonCommentVoteList operation.
     * @callback module:api/CommentApi~getTaxonCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getTaxonCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getTaxonCommentVoteList(acceptLanguage, taxonomyName, taxonId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonCommentVoteList");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonCommentVoteList");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getTaxonCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getTaxonCommentVoteList");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoComment operation.
     * @callback module:api/CommentApi~getVideoCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:api/CommentApi~getVideoCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    getVideoComment(acceptLanguage, videoId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoComment");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoComment");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentList operation.
     * @callback module:api/CommentApi~getVideoCommentListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment resources for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getVideoCommentListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentList>}
     */
    getVideoCommentList(acceptLanguage, videoId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentList");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoCommentList");
      }

      let pathParams = {
        'video_id': videoId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentList];
      return this.apiClient.callApi(
        '/videos/{video_id}/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentOptions operation.
     * @callback module:api/CommentApi~getVideoCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve the Video resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/CommentApi~getVideoCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse200}
     */
    getVideoCommentOptions(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/videos/{id}/options/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentVote operation.
     * @callback module:api/CommentApi~getVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/CommentApi~getVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getVideoCommentVote(acceptLanguage, videoId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentVoteList operation.
     * @callback module:api/CommentApi~getVideoCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/CommentApi~getVideoCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getVideoCommentVoteList(acceptLanguage, videoId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentVoteList");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getVideoCommentVoteList");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateArticleComment operation.
     * @callback module:api/CommentApi~updateArticleCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource of Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:model/CommentUpdate} comment The updated Comment resource
     * @param {module:api/CommentApi~updateArticleCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    updateArticleComment(acceptLanguage, articleId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateArticleComment");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateArticleComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateArticleComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateArticleComment");
      }

      let pathParams = {
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateArticleCommentOptions operation.
     * @callback module:api/CommentApi~updateArticleCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Comment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Article resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject1} opts.comment 
     * @param {module:api/CommentApi~updateArticleCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Comment}
     */
    updateArticleCommentOptions(acceptLanguage, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateArticleCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateArticleCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = Comment;
      return this.apiClient.callApi(
        '/articles/{id}/options/comments', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateArticleCommentVote operation.
     * @callback module:api/CommentApi~updateArticleCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/CommentApi~updateArticleCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateArticleCommentVote(acceptLanguage, articleId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateArticleCommentVote");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateArticleCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateArticleCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateArticleCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateArticleCommentVote");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForArticle operation.
     * @callback module:api/CommentApi~updateCommentVersionForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Article.
     * @param {String} commentId 
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/CommentApi~updateCommentVersionForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForArticle(commentId, articleId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateCommentVersionForArticle");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForArticle");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForArticle");
      }

      let pathParams = {
        'comment_id': commentId,
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForImage operation.
     * @callback module:api/CommentApi~updateCommentVersionForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Image.
     * @param {String} commentId 
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/CommentApi~updateCommentVersionForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForImage(commentId, imageId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateCommentVersionForImage");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForImage");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForImage");
      }

      let pathParams = {
        'comment_id': commentId,
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForProduct operation.
     * @callback module:api/CommentApi~updateCommentVersionForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Product.
     * @param {String} commentId 
     * @param {String} productId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/CommentApi~updateCommentVersionForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForProduct(commentId, productId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateCommentVersionForProduct");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForProduct");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForProduct");
      }

      let pathParams = {
        'comment_id': commentId,
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForRecipe operation.
     * @callback module:api/CommentApi~updateCommentVersionForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Recipe.
     * @param {String} commentId 
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/CommentApi~updateCommentVersionForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForRecipe(commentId, recipeId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateCommentVersionForRecipe");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForRecipe");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForRecipe");
      }

      let pathParams = {
        'comment_id': commentId,
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForTaxon operation.
     * @callback module:api/CommentApi~updateCommentVersionForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Taxon.
     * @param {String} commentId 
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/CommentApi~updateCommentVersionForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForTaxon(commentId, taxonomyName, taxonId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateCommentVersionForTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForTaxon");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForTaxon");
      }

      let pathParams = {
        'comment_id': commentId,
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForVideo operation.
     * @callback module:api/CommentApi~updateCommentVersionForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Video.
     * @param {String} commentId 
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/CommentApi~updateCommentVersionForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForVideo(commentId, videoId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateCommentVersionForVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForVideo");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForVideo");
      }

      let pathParams = {
        'comment_id': commentId,
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForArticle operation.
     * @callback module:api/CommentApi~updateCommentVersionOptionsForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Article.
     * @param {String} commentId 
     * @param {String} articleId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject2} opts.comment 
     * @param {module:api/CommentApi~updateCommentVersionOptionsForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForArticle(commentId, articleId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateCommentVersionOptionsForArticle");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForArticle");
      }

      let pathParams = {
        'comment_id': commentId,
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForImage operation.
     * @callback module:api/CommentApi~updateCommentVersionOptionsForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Image.
     * @param {String} commentId 
     * @param {String} imageId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject6} opts.comment 
     * @param {module:api/CommentApi~updateCommentVersionOptionsForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForImage(commentId, imageId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateCommentVersionOptionsForImage");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForImage");
      }

      let pathParams = {
        'comment_id': commentId,
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForProduct operation.
     * @callback module:api/CommentApi~updateCommentVersionOptionsForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Product.
     * @param {String} commentId 
     * @param {String} productId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject11} opts.comment 
     * @param {module:api/CommentApi~updateCommentVersionOptionsForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForProduct(commentId, productId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateCommentVersionOptionsForProduct");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForProduct");
      }

      let pathParams = {
        'comment_id': commentId,
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForRecipe operation.
     * @callback module:api/CommentApi~updateCommentVersionOptionsForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Recipe.
     * @param {String} commentId 
     * @param {String} recipeId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject15} opts.comment 
     * @param {module:api/CommentApi~updateCommentVersionOptionsForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForRecipe(commentId, recipeId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateCommentVersionOptionsForRecipe");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForRecipe");
      }

      let pathParams = {
        'comment_id': commentId,
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForTaxon operation.
     * @callback module:api/CommentApi~updateCommentVersionOptionsForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Taxon.
     * @param {String} commentId 
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject20} opts.comment 
     * @param {module:api/CommentApi~updateCommentVersionOptionsForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForTaxon(commentId, taxonomyName, taxonId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateCommentVersionOptionsForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateCommentVersionOptionsForTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForTaxon");
      }

      let pathParams = {
        'comment_id': commentId,
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForVideo operation.
     * @callback module:api/CommentApi~updateCommentVersionOptionsForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Video.
     * @param {String} commentId 
     * @param {String} videoId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject24} opts.comment 
     * @param {module:api/CommentApi~updateCommentVersionOptionsForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForVideo(commentId, videoId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateCommentVersionOptionsForVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForVideo");
      }

      let pathParams = {
        'comment_id': commentId,
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateImageComment operation.
     * @callback module:api/CommentApi~updateImageCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource of Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:model/CommentUpdate} comment The updated Comment resource
     * @param {module:api/CommentApi~updateImageCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    updateImageComment(acceptLanguage, imageId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateImageComment");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateImageComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateImageComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateImageComment");
      }

      let pathParams = {
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateImageCommentOptions operation.
     * @callback module:api/CommentApi~updateImageCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Comment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Image resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject7} opts.comment 
     * @param {module:api/CommentApi~updateImageCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Comment}
     */
    updateImageCommentOptions(acceptLanguage, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateImageCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateImageCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = Comment;
      return this.apiClient.callApi(
        '/images/{id}/options/comments', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateImageCommentVote operation.
     * @callback module:api/CommentApi~updateImageCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/CommentApi~updateImageCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateImageCommentVote(acceptLanguage, imageId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateImageCommentVote");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateImageCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateImageCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateImageCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateImageCommentVote");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateProductComment operation.
     * @callback module:api/CommentApi~updateProductCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource of Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} id 
     * @param {module:model/CommentUpdate} comment The updated Comment resource
     * @param {module:api/CommentApi~updateProductCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    updateProductComment(acceptLanguage, productId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateProductComment");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateProductComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateProductComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateProductComment");
      }

      let pathParams = {
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateProductCommentOptions operation.
     * @callback module:api/CommentApi~updateProductCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Comment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Product resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject12} opts.comment 
     * @param {module:api/CommentApi~updateProductCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Comment}
     */
    updateProductCommentOptions(acceptLanguage, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateProductCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateProductCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = Comment;
      return this.apiClient.callApi(
        '/products/{id}/options/comments', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateProductCommentVote operation.
     * @callback module:api/CommentApi~updateProductCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/CommentApi~updateProductCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateProductCommentVote(acceptLanguage, productId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateProductCommentVote");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateProductCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateProductCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateProductCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateProductCommentVote");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRecipeComment operation.
     * @callback module:api/CommentApi~updateRecipeCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource of Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:model/CommentUpdate} comment The updated Comment resource
     * @param {module:api/CommentApi~updateRecipeCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    updateRecipeComment(acceptLanguage, recipeId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateRecipeComment");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateRecipeComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateRecipeComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateRecipeComment");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRecipeCommentOptions operation.
     * @callback module:api/CommentApi~updateRecipeCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Comment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Recipe resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject16} opts.comment 
     * @param {module:api/CommentApi~updateRecipeCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Comment}
     */
    updateRecipeCommentOptions(acceptLanguage, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateRecipeCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateRecipeCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = Comment;
      return this.apiClient.callApi(
        '/recipes/{id}/options/comments', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRecipeCommentVote operation.
     * @callback module:api/CommentApi~updateRecipeCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/CommentApi~updateRecipeCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateRecipeCommentVote(acceptLanguage, recipeId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateRecipeCommentVote");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateRecipeCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateRecipeCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateRecipeCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateRecipeCommentVote");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxonComment operation.
     * @callback module:api/CommentApi~updateTaxonCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource of Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {module:model/CommentUpdate} comment The updated Comment resource
     * @param {module:api/CommentApi~updateTaxonCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    updateTaxonComment(acceptLanguage, taxonomyName, taxonId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateTaxonComment");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateTaxonComment");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateTaxonComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxonComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateTaxonComment");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxonCommentOptions operation.
     * @callback module:api/CommentApi~updateTaxonCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Comment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Taxon resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject22} opts.comment 
     * @param {module:api/CommentApi~updateTaxonCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Comment}
     */
    updateTaxonCommentOptions(acceptLanguage, taxonomyName, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateTaxonCommentOptions");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateTaxonCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxonCommentOptions");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = Comment;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}/options/comments', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxonCommentVote operation.
     * @callback module:api/CommentApi~updateTaxonCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/CommentApi~updateTaxonCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateTaxonCommentVote(acceptLanguage, taxonomyName, taxonId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateTaxonCommentVote");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoComment operation.
     * @callback module:api/CommentApi~updateVideoCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:model/CommentUpdate} comment The updated Comment resource
     * @param {module:api/CommentApi~updateVideoCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    updateVideoComment(acceptLanguage, videoId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateVideoComment");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateVideoComment");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoCommentOptions operation.
     * @callback module:api/CommentApi~updateVideoCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Comment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Video resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject25} opts.comment 
     * @param {module:api/CommentApi~updateVideoCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Comment}
     */
    updateVideoCommentOptions(acceptLanguage, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateVideoCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = Comment;
      return this.apiClient.callApi(
        '/videos/{id}/options/comments', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoCommentVote operation.
     * @callback module:api/CommentApi~updateVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/CommentApi~updateVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateVideoCommentVote(acceptLanguage, videoId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
